import React from 'react'
import PropTypes from 'prop-types';
import './_Warning.scss';

export const Warning = ({ children }) => {
    return (
        <div className="warning">
            {children}
        </div>
    );
};

Warning.propTypes = {
    children: PropTypes.element,
};
